import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import {
  getIsAsapAvailableForLocationAndMethodSelector,
  getOrderSettingAlertSelector,
  getFirstAvailableFulfillmentOption,
  todaySelector,
  getAvailableFulfillmentMethodSelector,
  getIsAsapAvailableWithThrottles,
  getIsPreviewMenuOn
} from 'bento-ordering/locations/selectors';
import {
  fulfillmentOptions,
  ALL_ONLINE_ORDERING_FULFILLMENT_METHODS
} from 'constants/fulfillmentOptions';

/**
 * A HOC to hold order setting data used by both OrderSettingRoute (mobile)
 * and OrderSettingModal (desktop)
 *
 * @param Component
 */
const withOrderSetting = Component => {
  class WithOrderSetting extends React.Component {
    static propTypes = {
      history: PropTypes.object.isRequired,
      match: PropTypes.object.isRequired,
      dispatch: PropTypes.func.isRequired,
      alert: PropTypes.string,
      isAsapAvailableForPickup: PropTypes.bool,
      isAsapAvailableForDelivery: PropTypes.bool,
      nextAvailablePickupTime: PropTypes.object,
      nextAvailableDeliveryTime: PropTypes.object,
      fulfillmentMethod: PropTypes.oneOf([
        fulfillmentOptions.DELIVERY,
        fulfillmentOptions.PICKUP
      ]),
      today: PropTypes.string,

      cartWorkingCopy: PropTypes.object,
      availableFulfillmentOptions: PropTypes.arrayOf(
        PropTypes.oneOf(ALL_ONLINE_ORDERING_FULFILLMENT_METHODS)
      ),
      metaData: PropTypes.object
    };

    render() {
      return <Component {...this.props} />;
    }
  }
  const mapStateToProps = state => {
    const {
      restaurantLocations,
      cart,
      alertStatus,
      cartWorkingCopy,
      locationThrottledTimes
    } = state;
    const { metaData } = alertStatus;
    const { online_ordering_location: locationId } = cart;

    const fulfillmentMethod = cart.online_ordering_fulfillment_method;

    const isAsapAvailableForPickup = getIsAsapAvailableForLocationAndMethodSelector(
      {
        restaurantLocationsState: restaurantLocations,
        locationThrottledTimesState: locationThrottledTimes,
        selectedMethod: fulfillmentOptions.PICKUP,
        cart: cartWorkingCopy,
        onlineOrderingLocation: cart.online_ordering_location
      }
    );

    const isAsapAvailableForDelivery = getIsAsapAvailableForLocationAndMethodSelector(
      {
        restaurantLocationsState: restaurantLocations,
        locationThrottledTimesState: locationThrottledTimes,
        selectedMethod: fulfillmentOptions.DELIVERY,
        cart: cartWorkingCopy,
        onlineOrderingLocation: cart.online_ordering_location
      }
    );
    const isAsapAvailableWithThrottles = getIsAsapAvailableWithThrottles({
      restaurantLocationsState: restaurantLocations,
      locationThrottledTimesState: locationThrottledTimes,
      onlineOrderingLocation: cart.online_ordering_location,
      cart: cartWorkingCopy
    });

    const isPreviewMenuOn = getIsPreviewMenuOn(state);
    const alert = getOrderSettingAlertSelector(
      isAsapAvailableForPickup,
      isAsapAvailableForDelivery,
      isAsapAvailableWithThrottles,
      alertStatus,
      isPreviewMenuOn
    );

    const nextAvailablePickupTime = getFirstAvailableFulfillmentOption({
      restaurantLocations,
      selectedLocationId: locationId,
      fulfillmentMethod: fulfillmentOptions.PICKUP,
      locationThrottledTimes,
      cart: cartWorkingCopy
    });

    const nextAvailableDeliveryTime = getFirstAvailableFulfillmentOption({
      restaurantLocations,
      selectedLocationId: locationId,
      fulfillmentMethod: fulfillmentOptions.DELIVERY,
      locationThrottledTimes,
      cart: cartWorkingCopy
    });
    const availableFulfillmentOptions = locationId
      ? getAvailableFulfillmentMethodSelector({
          restaurantLocations,
          locationThrottledTimes,
          cart,
          onlineOrderingLocation: locationId
        })
      : [];
    const today = todaySelector(restaurantLocations, locationId);

    return {
      metaData,
      fulfillmentMethod,
      nextAvailablePickupTime,
      nextAvailableDeliveryTime,
      today,
      cartWorkingCopy,
      availableFulfillmentOptions,
      isAsapAvailableForPickup,
      isAsapAvailableForDelivery,
      alert
    };
  };

  return connect(mapStateToProps)(WithOrderSetting);
};

export default withOrderSetting;
